import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Conclusion = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>Conclusion</Paragraph>
        <Text className='BaseText'>The DBTL cycle <b>allowed</b> us to design the <b>parts</b> our project has, which <b>biomarkers</b> we will use, the <b>type</b> of LFA, and so on. In the next phase of the cycle the build part helps us to <b>create a strategy</b> to prove our design in an <b>experimental</b> way and with <b>mathematical models</b>. The test cycle allows us to <b>obtain results</b> of what we have planned in the <b>build part.</b> Learning was one of the most important parts in the cycle. With this we had the opportunity to <b>analyze</b> what we have done and obtained. Now is time to continue <b>implementing </b>the use of this <b>technique</b> to continue developing our project.</Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Conclusion;
